<template>
  <q-toolbar style="min-height: 40px">
    <q-toolbar-title class="text-subtitle1 text-grey-7">
      <small><humanize-time :time="post.postedAt" /></small>
      <q-badge
        v-if="isArchived"
        color="orange"
        label="Archived"
        class="q-ml-sm"
      />
      <q-badge
        v-if="isTrashed"
        color="red"
        label="Trashed"
        class="q-ml-sm"
      />
    </q-toolbar-title>
    <post-time-context :date-of-loss="dateOfLoss" :posted-at="post.postedAt" />
  </q-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import HumanizeTime from '@/components/HumanizeTime.vue';
import PostTimeContext from './PostTimeContext.vue';
import { isArchived, isTrashed } from '../post';

export default defineComponent({
  components: { HumanizeTime, PostTimeContext },
  props: {
    post: {
      type: Object as () => Post,
    },
  },
  computed: {
    dateOfLoss(): string {
      return this.post.client.dateOfLoss;
    },
    isArchived(): boolean {
      return isArchived(this.post);
    },
    isTrashed(): boolean {
      return isTrashed(this.post);
    },
  },
});
</script>
